import type { DiscussionPeerActivityEvent } from '@jarvis/platform-file-review';

export function discussionFileBasename(path: string): string {
  const normalized = path.replace(/\\/g, '/').trim();
  const idx = normalized.lastIndexOf('/');
  return idx >= 0 ? normalized.slice(idx + 1) : normalized || 'file';
}

function activitySummary(changeType: string, authorName: string): string {
  switch (changeType) {
    case 'message-created':
      return `${authorName} sent a new message`;
    case 'message-updated':
      return `${authorName} edited a message`;
    case 'message-deleted':
      return `${authorName} removed a message`;
    case 'anchor-created':
      return `${authorName} added a selection comment`;
    case 'anchor-deleted':
      return `${authorName} removed a selection comment`;
    default:
      return `${authorName} updated the discussion`;
  }
}

export function formatDiscussionPeerActivityMessage(
  event: Pick<DiscussionPeerActivityEvent, 'changeType' | 'changedByDisplayName' | 'path'>
): string {
  const authorName = event.changedByDisplayName?.trim() || 'Someone';
  const fileName = discussionFileBasename(event.path);
  return `${activitySummary(event.changeType, authorName)} in ${fileName}`;
}

export function formatDiscussionPeerActivityTitle(
  event: Pick<DiscussionPeerActivityEvent, 'changeType' | 'changedByDisplayName'>
): string {
  const authorName = event.changedByDisplayName?.trim() || 'Someone';
  return activitySummary(event.changeType, authorName);
}
